export default function IconUser() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 32 32"
      fill="none"
    >
      <path
        d="M26 6V9.5C26 10.0523 26.4477 10.5 27 10.5C27.5523 10.5 28 10.0523 28 9.5V6C28 5.17157 27.4142 4.58579 27.4142 4.58579C26.8284 4 26 4 26 4H22.5C21.9477 4 21.5 4.44772 21.5 5C21.5 5.55228 21.9477 6 22.5 6H26Z"
        fill="#1C1C1C"
      />
      <path
        d="M28 26V22.5C28 21.9477 27.5523 21.5 27 21.5C26.4477 21.5 26 21.9477 26 22.5V26H22.5C21.9477 26 21.5 26.4477 21.5 27C21.5 27.5523 21.9477 28 22.5 28H26C26.8284 28 27.4142 27.4142 27.4142 27.4142C28 26.8284 28 26 28 26Z"
        fill="#1C1C1C"
      />
      <path
        d="M6 26V22.5C6 21.9477 5.55228 21.5 5 21.5C4.44772 21.5 4 21.9477 4 22.5V26C4 26.8284 4.58579 27.4142 4.58579 27.4142C5.17157 28 6 28 6 28H9.5C10.0523 28 10.5 27.5523 10.5 27C10.5 26.4477 10.0523 26 9.5 26H6Z"
        fill="#1C1C1C"
      />
      <path
        d="M4 6V9.5C4 10.0523 4.44772 10.5 5 10.5C5.55228 10.5 6 10.0523 6 9.5V6H9.5C10.0523 6 10.5 5.55228 10.5 5C10.5 4.44772 10.0523 4 9.5 4H6C5.17157 4 4.58579 4.58579 4.58579 4.58579C4 5.17157 4 6 4 6Z"
        fill="#1C1C1C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 9C16 9 18.0711 9 19.5355 10.4645C19.5355 10.4645 21 11.9289 21 14C21 14 21 16.0711 19.5355 17.5355C19.5355 17.5355 18.0711 19 16 19C16 19 13.9289 19 12.4645 17.5355C12.4645 17.5355 11 16.0711 11 14C11 14 11 11.9289 12.4645 10.4645C12.4645 10.4645 13.9289 9 16 9ZM16 11C16 11 14.7574 11 13.8787 11.8787C13.8787 11.8787 13 12.7574 13 14C13 14 13 15.2426 13.8787 16.1213C13.8787 16.1213 14.7574 17 16 17C16 17 17.2426 17 18.1213 16.1213C18.1213 16.1213 19 15.2426 19 14C19 14 19 12.7574 18.1213 11.8787C18.1213 11.8787 17.2426 11 16 11Z"
        fill="#1C1C1C"
      />
      <path
        d="M19.3576 19.9385C20.907 20.8708 21.754 22.4684 21.754 22.4684C21.8782 22.7027 22.0904 22.8781 22.3439 22.956C22.439 22.9852 22.538 23 22.6375 23C22.6525 23 22.6675 22.9997 22.6825 22.999C22.8304 22.9923 22.975 22.9529 23.1059 22.8836C23.433 22.7102 23.6375 22.3702 23.6375 22L23.6374 21.9898C23.6358 21.83 23.5959 21.6729 23.521 21.5316C22.414 19.4434 20.3888 18.2248 20.3888 18.2248C18.3635 17.0062 16 17.0062 16 17.0062C13.6364 17.0062 11.6112 18.2248 11.6112 18.2248C9.586 19.4434 8.47896 21.5316 8.47896 21.5316C8.40248 21.6759 8.36249 21.8367 8.36249 22L8.36249 22.0024C8.36338 22.3718 8.56778 22.7106 8.89411 22.8836C9.03838 22.96 9.19919 23 9.36249 23L9.36711 23C9.46505 22.9996 9.56241 22.9847 9.65604 22.956C9.90957 22.8781 10.1218 22.7027 10.246 22.4684C11.093 20.8708 12.6424 19.9385 12.6424 19.9385C14.1917 19.0062 16 19.0062 16 19.0062C17.8082 19.0062 19.3576 19.9385 19.3576 19.9385Z"
        fill="#1C1C1C"
      />
    </svg>
  );
}
